(function () {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const t = window.themeStrings || {};
  const routes = window.themeRoutes || {};
  const shopifyRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || routes.root || '/';
  const cartJs = routes.cartJs || `${shopifyRoot}cart.js`.replace(/\/{2,}/g, '/').replace(':/', '://');
  const cartAddJs = routes.cartAddJs || `${shopifyRoot}cart/add.js`.replace(/\/{2,}/g, '/').replace(':/', '://');
  const cartChangeJs = routes.cartChangeJs || `${shopifyRoot}cart/change.js`.replace(/\/{2,}/g, '/').replace(':/', '://');
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'da-DK', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  };
  const withAmount = (template, amount) => (template || '').replace(/\{\{\s*amount\s*\}\}/g, amount);
  const withVars = (template, vars) => {
    let out = template || '';
    Object.keys(vars || {}).forEach((key) => {
      out = out.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), String(vars[key]));
    });
    return out;
  };

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })
    : null;

  qsa('[data-reveal]').forEach((el, i) => {
    el.style.transitionDelay = (i % 4) * 80 + 'ms';
    if (io) io.observe(el);
    else el.classList.add('is-in');
  });

  /* Hero already in view */
  qsa('.hero-ritual [data-reveal], .about-hero [data-reveal]').forEach((el) => el.classList.add('is-in'));

  const drawer = qs('[data-side-cart]');
  const overlay = qs('[data-cart-overlay]');

  function openCart() {
    setMobileMenu(false);
    if (searchDrawer && searchDrawer.classList.contains('open')) {
      searchDrawer.classList.remove('open');
      searchDrawer.setAttribute('aria-hidden', 'true');
      if (searchOverlay) {
        searchOverlay.classList.remove('open');
        searchOverlay.hidden = true;
      }
      document.body.classList.remove('search-drawer-open');
      if (searchInput) searchInput.value = '';
    }
    if (drawer) {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    if (overlay) overlay.classList.add('open');
    document.body.classList.add('side-cart-open');
    document.body.style.overflow = 'hidden';
    const loy = qs('[data-ev-loyalty]');
    if (loy && loy.classList.contains('is-open')) {
      loy.classList.remove('is-open');
      const panel = qs('[data-ev-loyalty-panel]', loy);
      const backdrop = qs('.ev-loyalty__backdrop', loy);
      if (panel) {
        panel.setAttribute('aria-hidden', 'true');
        panel.hidden = true;
      }
      if (backdrop) backdrop.hidden = true;
      qsa('[data-ev-loyalty-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    }
    renderCart();
  }

  function closeCart() {
    if (drawer) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('open');
    document.body.classList.remove('side-cart-open');
    document.body.style.overflow = '';
    closeGiftModal();
  }

  function openGiftModal() {
    const modal = qs('[data-free-gift-modal]');
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeGiftModal() {
    const modal = qs('[data-free-gift-modal]');
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
  }

  qsa('[data-cart-open]').forEach((b) => b.addEventListener('click', openCart));
  qsa('[data-cart-close], [data-cart-overlay]').forEach((b) => b.addEventListener('click', closeCart));

  /* Search drawer + predictive search */
  const searchDrawer = qs('[data-search-drawer]');
  const searchOverlay = qs('[data-search-overlay]');
  const searchInput = qs('[data-search-input]');
  const searchIdle = qs('[data-search-idle]');
  const searchStatus = qs('[data-search-status]');
  const searchResults = qs('[data-search-results]');
  const searchFooter = qs('[data-search-footer]');
  const searchViewAll = qs('[data-search-view-all]');
  const searchForm = searchDrawer && qs('.search-drawer__form', searchDrawer);
  let searchTimer = null;
  let searchRequest = 0;

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const cleanSearchUrl = (url) => (url || '').split('?')[0];

  const formatSearchPrice = (price, compareAt) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    const locale = document.documentElement.lang || 'nl-NL';
    const fmt = (amount) => {
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(parseFloat(amount));
      } catch (e) {
        return '€' + String(amount).replace('.', ',');
      }
    };
    const current = fmt(price);
    if (compareAt && parseFloat(compareAt) > parseFloat(price)) {
      return `<s>${escapeHtml(fmt(compareAt))}</s>${escapeHtml(current)}`;
    }
    return escapeHtml(current);
  };

  function setSearchOpen(isOpen) {
    if (!searchDrawer || !searchOverlay) return;
    if (isOpen) {
      if (drawer && drawer.classList.contains('open')) closeCart();
      setMobileMenu(false);
    }
    searchDrawer.classList.toggle('open', isOpen);
    searchDrawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    searchOverlay.classList.toggle('open', isOpen);
    searchOverlay.hidden = !isOpen;
    document.body.classList.toggle('search-drawer-open', isOpen);
    if (isOpen) {
      window.setTimeout(() => searchInput && searchInput.focus(), 60);
    } else if (searchInput) {
      searchInput.value = '';
      resetSearchResults();
    }
  }

  function resetSearchResults() {
    if (searchIdle) searchIdle.hidden = false;
    if (searchStatus) {
      searchStatus.hidden = true;
      searchStatus.textContent = '';
    }
    if (searchResults) {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
    }
    if (searchFooter) searchFooter.hidden = true;
    if (searchViewAll && routes.searchUrl) searchViewAll.href = routes.searchUrl;
  }

  function renderSearchGroup(label, html) {
    if (!html) return '';
    return `<section class="search-drawer__group"><h3 class="search-drawer__group-label">${escapeHtml(label)}</h3><div class="search-drawer__list">${html}</div></section>`;
  }

  function renderSearchResults(data, query) {
    if (!searchResults) return;
    const results = (data && data.resources && data.resources.results) || {};
    const queries = results.queries || [];
    const products = results.products || [];
    const collections = results.collections || [];
    const pages = results.pages || [];
    const total = queries.length + products.length + collections.length + pages.length;

    if (searchIdle) searchIdle.hidden = true;
    if (searchStatus) searchStatus.hidden = true;

    if (!total) {
      if (searchStatus) {
        searchStatus.hidden = false;
        searchStatus.textContent = withVars(t.searchNoResults || 'No results for “{{ terms }}”', { terms: query });
      }
      searchResults.hidden = true;
      searchResults.innerHTML = '';
      if (searchFooter) searchFooter.hidden = true;
      return;
    }

    let html = '';
    if (queries.length) {
      html += renderSearchGroup(t.searchSuggestions || 'Suggestions', queries.map((item) => (
        `<a class="search-drawer__item search-drawer__item--query" href="${escapeHtml(cleanSearchUrl(item.url))}">
          <span class="search-drawer__meta"><span class="search-drawer__title">${escapeHtml(item.text || item.styled_text || '')}</span></span>
          <span class="search-drawer__arrow" aria-hidden="true">→</span>
        </a>`
      )).join(''));
    }
    if (products.length) {
      html += renderSearchGroup(t.searchProducts || 'Products', products.map((item) => {
        const image = (item.featured_image && item.featured_image.url) || item.image;
        const compareAt = parseFloat(item.compare_at_price_min) > parseFloat(item.price_min) ? item.compare_at_price_min : '';
        return `<a class="search-drawer__item" href="${escapeHtml(cleanSearchUrl(item.url))}">
          ${image
            ? `<img class="search-drawer__thumb" src="${escapeHtml(image)}" alt="" width="52" height="52" loading="lazy">`
            : '<span class="search-drawer__thumb search-drawer__thumb--empty" aria-hidden="true"></span>'}
          <span class="search-drawer__meta">
            <span class="search-drawer__title">${escapeHtml(item.title)}</span>
            ${item.type ? `<span class="search-drawer__subtitle">${escapeHtml(item.type)}</span>` : ''}
          </span>
          <span class="search-drawer__price">${formatSearchPrice(item.price_min || item.price, compareAt)}</span>
        </a>`;
      }).join(''));
    }
    if (collections.length) {
      html += renderSearchGroup(t.searchCollections || 'Collections', collections.map((item) => (
        `<a class="search-drawer__item search-drawer__item--collection" href="${escapeHtml(cleanSearchUrl(item.url))}">
          <span class="search-drawer__meta"><span class="search-drawer__title">${escapeHtml(item.title)}</span></span>
          <span class="search-drawer__arrow" aria-hidden="true">→</span>
        </a>`
      )).join(''));
    }
    if (pages.length) {
      html += renderSearchGroup(t.searchPages || 'Pages', pages.map((item) => (
        `<a class="search-drawer__item search-drawer__item--page" href="${escapeHtml(cleanSearchUrl(item.url))}">
          <span class="search-drawer__meta"><span class="search-drawer__title">${escapeHtml(item.title)}</span></span>
          <span class="search-drawer__arrow" aria-hidden="true">→</span>
        </a>`
      )).join(''));
    }

    searchResults.innerHTML = html;
    searchResults.hidden = false;
    if (searchFooter) searchFooter.hidden = false;
    if (searchViewAll && routes.searchUrl) {
      searchViewAll.href = `${routes.searchUrl}?q=${encodeURIComponent(query)}`;
    }
  }

  async function fetchSearchSuggestions(query) {
    if (!routes.searchSuggestUrl) return;
    const requestId = ++searchRequest;
    if (searchStatus) {
      searchStatus.hidden = false;
      searchStatus.textContent = t.searchLoading || 'Searching…';
    }
    if (searchIdle) searchIdle.hidden = true;
    if (searchResults) searchResults.hidden = true;

    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'query,product,collection,page',
      'resources[limit]': '6',
      'resources[limit_scope]': 'each',
      'resources[options][unavailable_products]': 'hide'
    });

    try {
      const res = await fetch(`${routes.searchSuggestUrl}?${params.toString()}`);
      if (!res.ok) throw new Error('search failed');
      const data = await res.json();
      if (requestId !== searchRequest) return;
      renderSearchResults(data, query);
    } catch (e) {
      if (requestId !== searchRequest) return;
      if (searchStatus) {
        searchStatus.hidden = false;
        searchStatus.textContent = withVars(t.searchNoResults || 'No results for “{{ terms }}”', { terms: query });
      }
      if (searchResults) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
      }
      if (searchFooter) searchFooter.hidden = true;
    }
  }

  function handleSearchInput() {
    const query = (searchInput && searchInput.value || '').trim();
    window.clearTimeout(searchTimer);
    if (!query) {
      searchRequest += 1;
      resetSearchResults();
      return;
    }
    searchTimer = window.setTimeout(() => fetchSearchSuggestions(query), 220);
  }

  if (searchDrawer) {
    qsa('[data-search-open]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        setSearchOpen(true);
      });
    });
    qsa('[data-search-close], [data-search-overlay]').forEach((btn) => {
      btn.addEventListener('click', () => setSearchOpen(false));
    });
    if (searchInput) searchInput.addEventListener('input', handleSearchInput);
    if (searchForm) {
      searchForm.addEventListener('submit', () => setSearchOpen(false));
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchDrawer.classList.contains('open')) setSearchOpen(false);
    });
  }

  /* Header: condensed state on scroll */
  const siteHeader = qs('[data-header]');
  if (siteHeader) {
    let ticking = false;
    const syncHeader = () => {
      siteHeader.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(syncHeader);
      }
    }, { passive: true });
    syncHeader();
  }

  /* Announcement rotation (visible one-at-a-time on small screens) */
  const announcement = qs('[data-announcement]');
  if (announcement) {
    const items = qsa('.announcement__item', announcement);
    if (items.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let idx = 0;
      window.setInterval(() => {
        items[idx].classList.remove('is-active');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active');
      }, 4500);
    }
  }

  /* Desktop mega menu */
  const navItems = qsa('[data-nav-item].has-dropdown');
  const closeMega = (except) => {
    navItems.forEach((item) => {
      if (item === except) return;
      item.classList.remove('open');
      const b = qs('.submenu-toggle', item);
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  };
  navItems.forEach((item) => {
    const btn = qs('.submenu-toggle', item);
    let leaveTimer;
    const open = () => {
      window.clearTimeout(leaveTimer);
      closeMega(item);
      item.classList.add('open');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      item.classList.remove('open');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', () => {
      leaveTimer = window.setTimeout(close, 140);
    });
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) close();
    });
    if (btn) {
      btn.addEventListener('click', () => {
        if (item.classList.contains('open')) close();
        else open();
      });
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMega();
  });

  /* Mobile drawer with drill-down panels */
  const menuBtn = qs('[data-menu-toggle]');
  const mobile = qs('[data-mobile-menu]');
  const mobileOverlay = qs('[data-mobile-overlay]');

  function showMobilePanel(id) {
    const mobile = qs('[data-mobile-menu]');
    if (!mobile) return;
    qsa('[data-mobile-panel]', mobile).forEach((panel) => {
      const isTarget = panel.dataset.mobilePanel === id;
      const isRoot = panel.dataset.mobilePanel === 'root';
      panel.classList.toggle('is-current', isTarget);
      panel.classList.toggle('is-behind', isRoot && id !== 'root');
      panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
      if (isTarget) panel.removeAttribute('inert');
      else panel.setAttribute('inert', '');
      if (isTarget) panel.scrollTop = 0;
    });
    qsa('[data-mobile-open]', mobile).forEach((b) => {
      b.setAttribute('aria-expanded', b.dataset.mobileOpen === id ? 'true' : 'false');
    });
  }

  function setMobileMenu(isOpen) {
    const mobile = qs('[data-mobile-menu]');
    const menuBtn = qs('[data-menu-toggle]');
    const mobileOverlay = qs('[data-mobile-overlay]');
    if (!mobile) return;
    if (isOpen === mobile.classList.contains('open')) return;
    mobile.classList.toggle('open', isOpen);
    mobile.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (isOpen) mobile.removeAttribute('inert');
    else mobile.setAttribute('inert', '');
    if (mobileOverlay) {
      if (isOpen) mobileOverlay.hidden = false;
      window.requestAnimationFrame(() => mobileOverlay.classList.toggle('open', isOpen));
      if (!isOpen) window.setTimeout(() => { if (!mobile.classList.contains('open')) mobileOverlay.hidden = true; }, 450);
    }
    document.body.classList.toggle('mobile-menu-open', isOpen);
    if (menuBtn) menuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) {
      showMobilePanel('root');
      const closeBtn = qs('[data-menu-close]', mobile);
      window.setTimeout(() => closeBtn && closeBtn.focus({ preventScroll: true }), 60);
    } else if (menuBtn && mobile.contains(document.activeElement)) {
      menuBtn.focus({ preventScroll: true });
    }
  }

  if (menuBtn && mobile) {
    menuBtn.addEventListener('click', () => setMobileMenu(!mobile.classList.contains('open')));
    qsa('[data-menu-close]', mobile).forEach((b) => b.addEventListener('click', () => setMobileMenu(false)));
    if (mobileOverlay) mobileOverlay.addEventListener('click', () => setMobileMenu(false));
    qsa('[data-mobile-open]', mobile).forEach((b) => {
      b.addEventListener('click', () => {
        showMobilePanel(b.dataset.mobileOpen);
        const panel = qs(`[data-mobile-panel="${b.dataset.mobileOpen}"]`, mobile);
        const back = panel && qs('[data-mobile-back]', panel);
        window.setTimeout(() => back && back.focus({ preventScroll: true }), 60);
      });
    });
    qsa('[data-mobile-back]', mobile).forEach((b) => {
      b.addEventListener('click', () => {
        const from = b.closest('[data-mobile-panel]').dataset.mobilePanel;
        showMobilePanel('root');
        const opener = qs(`[data-mobile-open="${from}"]`, mobile);
        window.setTimeout(() => opener && opener.focus({ preventScroll: true }), 60);
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobile.classList.contains('open')) setMobileMenu(false);
    });
    window.matchMedia('(min-width: 981px)').addEventListener('change', (e) => {
      if (e.matches) setMobileMenu(false);
    });
  }

  async function getCart() {
    const r = await fetch(cartJs, { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function addItem(id, qty = 1) {
    const r = await fetch(cartAddJs, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: Number(qty) })
    });
    if (!r.ok) throw new Error('add failed');
    await renderCart();
    openCart();
  }

  async function changeItem(key, qty) {
    const nextQty = Number(qty);
    try {
      const current = await getCart();
      const giftIds = getFreeGiftIds();
      const line = (current.items || []).find((item) => item.key === key);
      if (line && giftIds.includes(Number(line.variant_id)) && nextQty > 1) {
        updateFreeGift(current);
        return;
      }
    } catch (e) {}
    await fetch(cartChangeJs, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: nextQty })
    });
    await renderCart();
  }

  function updateCount(cart) {
    qsa('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    qsa('[data-cart-heading-count]').forEach((el) => (el.textContent = cart.item_count));
  }

  function updateMeter(cart) {
    const meter = qs('[data-shipping-meter]');
    if (!meter) return;
    const threshold = Number(meter.dataset.threshold || 0);
    const msg = qs('[data-shipping-message]', meter);
    const bar = qs('[data-shipping-bar]', meter);
    if (!threshold) return;
    const left = Math.max(threshold - cart.total_price, 0);
    const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    if (bar) bar.style.width = pct + '%';
    if (msg) {
      msg.textContent = left > 0
        ? withAmount(t.shippingLeft || 'Nog {{ amount }} tot gratis verzending', money(left))
        : (t.shippingReached || 'Je hebt gratis verzending bereikt');
    }
  }

  function getFreeGiftIds() {
    const box = qs('[data-free-gift]');
    if (!box) return [];
    const ids = qsa('[data-free-gift-option]', box)
      .map((b) => Number(b.dataset.variantId || 0))
      .filter(Boolean);
    const fallback = Number(box.dataset.variantId || 0);
    if (fallback && !ids.includes(fallback)) ids.push(fallback);
    return Array.from(new Set(ids));
  }

  function cartHasFreeGift(cart, giftIds = getFreeGiftIds()) {
    return giftIds.length
      ? (cart.items || []).some((item) => giftIds.includes(Number(item.variant_id)))
      : false;
  }

  async function cleanFreeGiftCart(cart) {
    const box = qs('[data-free-gift]');
    if (!box || box.dataset.enabled !== 'true') return cart;
    const threshold = Number(box.dataset.threshold || 4500);
    const giftIds = getFreeGiftIds();
    if (!threshold || !giftIds.length) return cart;
    const giftLines = (cart.items || []).filter((item) => giftIds.includes(Number(item.variant_id)));
    if (!giftLines.length) return cart;
    const shouldRemoveAll = Number(cart.total_price || 0) < threshold;
    const linesToRemove = shouldRemoveAll ? giftLines : giftLines.slice(1);
    if (!linesToRemove.length) return cart;
    await Promise.all(
      linesToRemove.map((line) =>
        fetch(cartChangeJs, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        })
      )
    );
    return getCart();
  }

  function updateFreeGift(cart) {
    const box = qs('[data-free-gift]');
    if (!box) return;
    const enabled = box.dataset.enabled === 'true';
    const threshold = Number(box.dataset.threshold || 4500);
    const msg = qs('[data-free-gift-message]', box);
    const buttons = qsa('[data-free-gift-add]', box);
    const optionButtons = qsa('[data-free-gift-option]', box);
    const openButton = qs('[data-free-gift-open]', box);
    const giftIds = getFreeGiftIds();

    if (!enabled || !threshold) {
      box.hidden = true;
      return;
    }
    box.hidden = false;

    const total = Number(cart.total_price || 0);
    const eligible = total >= threshold;
    const hasAnyGift = cartHasFreeGift(cart, giftIds);
    const unconfigured = giftIds.length === 0;

    box.classList.toggle('is-eligible', eligible && !hasAnyGift && !unconfigured);
    box.classList.toggle('is-added', hasAnyGift);

    if (unconfigured) {
      if (msg) msg.textContent = t.giftConfigure || 'Stel een cadeaucollectie of variant-ID in via de theme-instellingen.';
      buttons.forEach((btn) => (btn.disabled = true));
      if (openButton) openButton.hidden = true;
      closeGiftModal();
      return;
    }

    if (hasAnyGift) {
      if (msg) msg.textContent = t.giftAdded || 'Je gratis cadeau zit in je winkelwagen.';
      buttons.forEach((btn) => {
        btn.disabled = true;
        if (btn.classList.contains('free-gift-button')) btn.textContent = t.added || 'Toegevoegd';
      });
      optionButtons.forEach((btn) => btn.classList.add('is-disabled'));
      if (openButton) openButton.hidden = true;
      closeGiftModal();
      return;
    }

    const left = Math.max(threshold - total, 0);
    if (msg) {
      msg.textContent = eligible
        ? (t.giftReady || 'Je gratis cadeau staat klaar. Kies er één.')
        : withAmount(t.giftLeft || 'Nog {{ amount }} tot je gratis cadeau.', money(left));
    }
    if (openButton) {
      openButton.hidden = !eligible;
      openButton.disabled = !eligible;
    }
    if (!eligible) closeGiftModal();
    buttons.forEach((btn) => {
      const unavailable = btn.dataset.giftUnavailable === 'true';
      btn.disabled = !eligible || unavailable;
    });
    optionButtons.forEach((btn) => {
      const unavailable = btn.dataset.giftUnavailable === 'true';
      btn.disabled = !eligible || unavailable;
      btn.classList.toggle('is-disabled', !eligible || unavailable);
    });
  }

  async function renderCart() {
    if (!drawer) return;
    let cart = await getCart();
    cart = await cleanFreeGiftCart(cart);
    updateCount(cart);
    updateMeter(cart);
    updateFreeGift(cart);

    const items = qs('[data-cart-items]');
    const total = qs('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    if (!items) return;

    if (!cart.items.length) {
      items.innerHTML =
        '<div class="side-cart__empty"><h3>' + (t.cartEmpty || 'Je winkelwagen is nog leeg') + '</h3><p>' + (t.cartEmptyText || '') + '</p><a class="btn btn--gold" href="' + (t.collectionsAll || '/collections/all') + '">' + (t.cartEmptyCta || '') + '</a></div>';
      return;
    }

    const giftIds = getFreeGiftIds();
    items.innerHTML = cart.items
      .map((item) => {
        const isGift = giftIds.includes(Number(item.variant_id));
        const qtyControls = isGift
          ? `<div class="pro-drawer-qty"><span>${item.quantity}</span></div>`
          : `<div class="pro-drawer-qty"><button type="button" aria-label="${t.less || 'Less'}" data-change="${item.key}" data-qty="${item.quantity - 1}">−</button><span>${item.quantity}</span><button type="button" aria-label="${t.more || 'More'}" data-change="${item.key}" data-qty="${item.quantity + 1}">+</button></div>`;
        return `<div class="drawer-line${isGift ? ' is-free-gift-line' : ''}">
          <a href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
          <div>
            <a class="pro-line-title" href="${item.url}">${item.product_title}</a>
            ${isGift ? '<small class="pro-line-gift-label">' + (t.freeGift || 'Gratis cadeau') + '</small>' : item.variant_title ? `<small>${item.variant_title}</small>` : ''}
            ${qtyControls}
          </div>
          <div class="pro-line-side">
            <strong>${money(item.final_line_price)}</strong>
            <button type="button" class="pro-remove" data-change="${item.key}" data-qty="0">${t.cartRemove || 'Remove'}</button>
          </div>
        </div>`;
      })
      .join('');

    qsa('[data-change]', items).forEach((b) =>
      b.addEventListener('click', () => changeItem(b.dataset.change, b.dataset.qty))
    );
  }

  document.addEventListener(
    'touchend',
    (e) => {
      const checkout = e.target.closest('[data-checkout-button]');
      if (!checkout) return;
      const form = checkout.closest('[data-sidecart-checkout-form]');
      if (!form) return;
      e.preventDefault();
      checkout.disabled = true;
      checkout.textContent = t.checkoutLoading || 'Proceeding to checkout…';
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    },
    { passive: false }
  );

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    try {
      await addItem(fd.get('id'), fd.get('quantity') || 1);
    } catch (err) {
      form.submit();
    }
  });

  document.addEventListener('click', async (e) => {
    const giftOpen = e.target.closest('[data-free-gift-open]');
    if (giftOpen) {
      e.preventDefault();
      if (!giftOpen.disabled) openGiftModal();
      return;
    }

    const giftClose = e.target.closest('[data-free-gift-close]');
    if (giftClose) {
      e.preventDefault();
      closeGiftModal();
      return;
    }

    const gift = e.target.closest('[data-free-gift-add]');
    if (gift) {
      e.preventDefault();
      const box = gift.closest('[data-free-gift]');
      const id = gift.dataset.variantId || (box ? box.dataset.variantId : null);
      if (!id || gift.disabled) return;
      gift.disabled = true;
      const oldText = gift.textContent;
      try {
        const current = await getCart();
        const giftIds = getFreeGiftIds();
        if (cartHasFreeGift(current, giftIds)) {
          await renderCart();
          return;
        }
        const threshold = Number(box?.dataset.threshold || 4500);
        if (Number(current.total_price || 0) < threshold) {
          updateFreeGift(current);
          gift.disabled = false;
          gift.textContent = oldText;
          return;
        }
        await addItem(id, 1);
        closeGiftModal();
      } catch (err) {
        gift.disabled = false;
        gift.textContent = oldText;
      }
      return;
    }

    const checkout = e.target.closest('[data-checkout-button]');
    if (checkout) {
      const form = checkout.closest('[data-sidecart-checkout-form]');
      if (form) {
        e.preventDefault();
        checkout.disabled = true;
        checkout.textContent = t.checkoutLoading || 'Proceeding to checkout…';
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
      return;
    }

    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      await addItem(qa.dataset.variantId, 1);
    }

    const pm = e.target.closest('[data-qty-minus]');
    if (pm) {
      const inp = pm.parentElement.querySelector('input');
      inp.value = Math.max(1, Number(inp.value || 1) - 1);
    }
    const pp = e.target.closest('[data-qty-plus]');
    if (pp) {
      const inp = pp.parentElement.querySelector('input');
      inp.value = Number(inp.value || 1) + 1;
    }

    const stickyAdd = e.target.closest('[data-sticky-add]');
    if (stickyAdd) {
      e.preventDefault();
      const submit = document.querySelector('.product-form .add-to-cart');
      const form = document.querySelector('[data-product-form]');
      if (submit && !submit.disabled) submit.click();
      else if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeGiftModal();
      closeCart();
    }
  });

  qsa('[data-accordion] button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.nextElementSibling;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
    });
  });

  /* Judge.me write-review fallback when widget chrome is hidden */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-write-review]');
    if (!btn) return;
    const productId = btn.dataset.productId;
    const openNative = () => {
      try {
        if (window.jdgm?.customize?.openReviewForm) {
          window.jdgm.customize.openReviewForm({ productId: productId });
          return true;
        }
      } catch (err) {}
      try {
        if (window.jdgm?.openReviewForm) {
          window.jdgm.openReviewForm({ product_id: productId });
          return true;
        }
      } catch (err) {}
      return false;
    };
    // Give Judge.me's own .jdgm-write-rev-link handler a tick; then fallback.
    window.setTimeout(() => {
      if (document.querySelector('.jdgm-form, .jdgm-write-rev-popup, .jdgm-rev-widg__form, [class*="jdgm-form"]')) return;
      if (openNative()) return;
      const mount = document.getElementById('judgeme_product_reviews');
      if (mount) {
        mount.classList.remove('visually-hidden');
        mount.removeAttribute('aria-hidden');
        mount.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 120);
  });

  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-cart-line-change]');
    if (!a) return;
    e.preventDefault();
    a.style.pointerEvents = 'none';
    try {
      await fetch(cartChangeJs, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(a.dataset.line), quantity: Number(a.dataset.qty) })
      });
      window.location.reload();
    } catch (err) {
      window.location.href = a.href;
    }
  });

  /* Routine builder */
  qsa('[data-routine-builder]').forEach((builder) => {
    let need = 'hair-loss';
    let level = 'essential';
    const cards = qsa('[data-routine-card]', builder);
    const fallback = qs('[data-routine-fallback]', builder);

    function showMatch() {
      const match =
        cards.find((c) => c.dataset.need === need && c.dataset.level === level) ||
        cards.find((c) => c.dataset.need === need) ||
        cards[0];
      cards.forEach((c) => c.classList.add('hidden'));
      if (fallback) fallback.classList.add('hidden');
      if (match) match.classList.remove('hidden');
      else if (fallback) fallback.classList.remove('hidden');
    }

    qsa('[data-routine-need]', builder).forEach((btn) =>
      btn.addEventListener('click', () => {
        need = btn.dataset.routineNeed;
        qsa('[data-routine-need]', builder).forEach((b) => b.classList.toggle('is-active', b === btn));
        showMatch();
      })
    );
    qsa('[data-routine-level]', builder).forEach((btn) =>
      btn.addEventListener('click', () => {
        level = btn.dataset.routineLevel;
        qsa('[data-routine-level]', builder).forEach((b) => b.classList.toggle('is-active', b === btn));
        showMatch();
      })
    );
    qsa('[data-routine-add]', builder).forEach((btn) =>
      btn.addEventListener('click', async () => {
        const ids = (btn.dataset.variantIds || '')
          .split(',')
          .map((x) => x.trim())
          .filter(Boolean);
        if (!ids.length) {
          btn.textContent = t.routineLinkProducts || 'Link products first';
          btn.disabled = true;
          return;
        }
        btn.disabled = true;
        const old = btn.textContent;
        btn.textContent = t.routineAdding || 'Adding routine…';
        try {
          await fetch(cartAddJs, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
          });
          await renderCart();
          openCart();
          btn.textContent = t.added || 'Toegevoegd';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = old;
          }, 1400);
        } catch (err) {
          btn.disabled = false;
          btn.textContent = t.routineRetry || 'Try again';
        }
      })
    );
    showMatch();
  });

  /* Wishlist */
  const WISHLIST_KEY = 'evergetikon_wishlist_v1';
  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function writeWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    updateWishlistUI();
  }
  function isWishlisted(handle) {
    return readWishlist().some((i) => i.handle === handle);
  }
  function updateWishlistUI() {
    const items = readWishlist();
    qsa('[data-wishlist-count]').forEach((el) => {
      el.textContent = items.length;
      el.classList.toggle('is-zero', items.length === 0);
    });
    qsa('[data-wishlist-toggle]').forEach((btn) => {
      const saved = isWishlisted(btn.dataset.productHandle);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      const label = btn.querySelector('span');
      if (label) {
        label.textContent = saved
          ? (btn.dataset.wishlistSaved || 'Bewaard')
          : (btn.dataset.wishlistSave || 'Bewaar');
      }
    });
    renderWishlistPage();
  }
  function toggleWishlist(btn) {
    const item = {
      handle: btn.dataset.productHandle,
      title: btn.dataset.productTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice,
      variantId: btn.dataset.variantId
    };
    if (!item.handle) return;
    let items = readWishlist();
    if (items.some((i) => i.handle === item.handle)) {
      items = items.filter((i) => i.handle !== item.handle);
    } else {
      items.unshift(item);
    }
    writeWishlist(items.slice(0, 60));
  }
  function renderWishlistPage() {
    const grid = qs('[data-wishlist-grid]');
    if (!grid) return;
    const empty = qs('[data-wishlist-empty]');
    const items = readWishlist();
    if (empty) empty.classList.toggle('hidden', items.length > 0);
    grid.innerHTML = items
      .map(
        (item) => `<article class="product-card">
        <a class="product-card__media" href="${item.url || '#'}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
        <div class="product-card__info">
          <a href="${item.url || '#'}"><h3>${item.title || 'Product'}</h3></a>
          <div class="price-row"><strong>${item.price || ''}</strong></div>
          <div style="display:grid;gap:.5rem">
            ${item.variantId ? `<button class="btn btn--gold btn--small" type="button" data-quick-add data-variant-id="${item.variantId}">${t.addToCart || 'In winkelwagen'}</button>` : ''}
            <button class="btn btn--ghost btn--small" type="button" data-wishlist-remove="${item.handle}">${t.cartRemove || 'Remove'}</button>
          </div>
        </div>
      </article>`
      )
      .join('');
  }

  document.addEventListener('click', (e) => {
    const w = e.target.closest('[data-wishlist-toggle]');
    if (w) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(w);
      return;
    }
    const r = e.target.closest('[data-wishlist-remove]');
    if (r) {
      e.preventDefault();
      writeWishlist(readWishlist().filter((i) => i.handle !== r.dataset.wishlistRemove));
    }
  });

  updateWishlistUI();
  renderCart().catch(() => {});

  /* Collection filters: open on desktop, collapsed on mobile for faster browse */
  qsa('[data-collection-filters]').forEach((el) => {
    const desktop = window.matchMedia('(min-width: 981px)');
    const sync = () => {
      if (desktop.matches) el.setAttribute('open', '');
      else el.removeAttribute('open');
    };
    sync();
    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    else if (desktop.addListener) desktop.addListener(sync);
  });

  /* Product variant pills */
  function formatMoney(cents) {
    return money(Number(cents));
  }

  function getLoyaltyEarnPerEuro() {
    try {
      const rules = (window._ALConfig && window._ALConfig.pointEarnRules) || [];
      const purchase = rules.find((r) => r && r.type === 'PURCHASE' && r.status === 'ACTIVE');
      return Number(purchase && purchase.basePoints) || 10;
    } catch (e) {
      return 10;
    }
  }

  function syncProductLoyaltyEarn(priceCents, qty) {
    const el = qs('[data-product-loyalty-earn]');
    if (!el) return;
    const perEuro = getLoyaltyEarnPerEuro();
    const unit = Number(priceCents != null ? priceCents : el.dataset.priceCents) || 0;
    const amount = Math.max(1, Number(qty) || 1);
    if (priceCents != null) el.dataset.priceCents = String(unit);
    el.dataset.earnPerEuro = String(perEuro);
    const pts = Math.floor((unit / 100) * perEuro) * amount;
    const ptsEl = qs('[data-product-loyalty-earn-points]', el);
    if (ptsEl) {
      const locale = document.documentElement.lang || 'nl';
      ptsEl.textContent = new Intl.NumberFormat(locale).format(pts);
    }
    el.hidden = pts <= 0;
  }

  qsa('[data-product-form]').forEach((form) => {
    const picker = form.querySelector('[data-variant-picker]');
    const select = form.querySelector('[data-variant-select]');
    const qtyInput = form.querySelector('[name="quantity"], [data-qty-input]');

    if (!picker || !select || select.tagName !== 'SELECT') {
      const refresh = () => {
        const earnEl = qs('[data-product-loyalty-earn]');
        const price = Number((earnEl && earnEl.dataset.priceCents) || 0);
        syncProductLoyaltyEarn(price, Math.max(1, Number(qtyInput && qtyInput.value) || 1));
      };
      form.addEventListener('change', (e) => {
        if (e.target.matches('[name="quantity"], [data-qty-input]')) refresh();
      });
      form.addEventListener('input', (e) => {
        if (e.target.matches('[name="quantity"], [data-qty-input]')) refresh();
      });
      refresh();
      return;
    }

    const priceEl = document.querySelector('[data-price]');
    const compareEl = document.querySelector('[data-compare-price]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const addBtn = form.querySelector('[data-add-to-cart]');
    const wishlistBtn = form.querySelector('[data-wishlist-toggle]');

    function syncInciScore(barcode) {
      const root = qs('[data-inci-score]');
      if (!root) return;
      if (!barcode) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      root.href = `https://incibeauty.com/produit/${encodeURIComponent(barcode)}`;
      const img = root.querySelector('img');
      const tag = root.querySelector('ibscore');
      if (img) {
        try {
          const url = new URL(img.src);
          url.searchParams.set('ean', barcode);
          img.src = url.toString();
        } catch (err) {
          img.src = img.src.replace(/([?&]ean=)[^&]*/, `$1${encodeURIComponent(barcode)}`);
        }
        img.onload = () => { root.hidden = false; };
        img.onerror = () => { root.hidden = true; };
      } else if (tag) {
        tag.dataset.ean = barcode;
      }
    }

    function selectedOptions() {
      return [1, 2, 3].map((pos) => {
        const input = form.querySelector(`input[data-option-position="${pos}"]:checked`);
        return input ? input.value : null;
      });
    }

    function findVariant() {
      const [o1, o2, o3] = selectedOptions();
      return Array.from(select.options).find((opt) => {
        if (!opt.value) return false;
        const match1 = !o1 || opt.dataset.option1 === o1;
        const match2 = !o2 || opt.dataset.option2 === o2;
        const match3 = !o3 || opt.dataset.option3 === o3;
        return match1 && match2 && match3;
      });
    }

    function currentQty() {
      return Math.max(1, Number(qtyInput && qtyInput.value) || 1);
    }

    function syncVariant() {
      const opt = findVariant();
      if (!opt) return;
      select.value = opt.value;
      const available = opt.dataset.available === 'true';
      const price = Number(opt.dataset.price || 0);
      const compare = Number(opt.dataset.compare || 0);

      if (priceEl) priceEl.textContent = formatMoney(price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(price);
      if (compareEl) {
        if (compare > price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(compare);
        } else {
          compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? (t.addToCart || 'In winkelwagen') : (t.soldOut || 'Uitverkocht');
      }
      const stickyAdd = document.querySelector('[data-sticky-add]');
      if (stickyAdd) {
        stickyAdd.disabled = !available;
        stickyAdd.textContent = available ? (t.addToCart || 'In winkelwagen') : (t.soldOut || 'Uitverkocht');
      }
      if (wishlistBtn) {
        wishlistBtn.dataset.variantId = opt.value;
        wishlistBtn.dataset.productPrice = formatMoney(price);
      }

      qsa('.variant-pill', form).forEach((pill) => {
        const input = pill.querySelector('input');
        pill.classList.toggle('is-active', !!(input && input.checked));
      });

      syncProductLoyaltyEarn(price, currentQty());
      const loyaltyRoot = qs('[data-ev-loyalty]');
      if (loyaltyRoot) loyaltyRoot.dataset.productPrice = String(price);
      syncInciScore(opt.dataset.barcode || '');
    }

    form.addEventListener('change', (e) => {
      if (e.target.matches('[data-option-position]')) syncVariant();
      if (e.target.matches('[name="quantity"], [data-qty-input]')) {
        const opt = findVariant();
        const price = Number((opt && opt.dataset.price) || 0);
        syncProductLoyaltyEarn(price, currentQty());
      }
    });
    form.addEventListener('input', (e) => {
      if (e.target.matches('[name="quantity"], [data-qty-input]')) {
        const opt = findVariant();
        const price = Number((opt && opt.dataset.price) || 0);
        syncProductLoyaltyEarn(price, currentQty());
      }
    });
    syncVariant();
  });

  /* Product gallery: thumbs + scroll-snap sync */
  qsa('[data-product-gallery]').forEach((gallery) => {
    const viewport = qs('[data-gallery-viewport]', gallery);
    const thumbs = qsa('[data-gallery-thumb]', gallery);
    const slides = qsa('[data-gallery-slide]', gallery);
    if (!viewport || !slides.length) return;

    function goTo(index) {
      const slide = slides[index];
      if (!slide) return;
      viewport.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      thumbs.forEach((thumb, i) => {
        const on = i === index;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => goTo(Number(thumb.dataset.index || 0)));
    });

    let ticking = false;
    viewport.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const idx = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
          thumbs.forEach((thumb, i) => {
            const on = i === idx;
            thumb.classList.toggle('is-active', on);
            thumb.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          ticking = false;
        });
      },
      { passive: true }
    );
  });

  /* Sticky ATC only when main button leaves the viewport */
  const stickyBuy = qs('[data-sticky-buy]');
  const atcBtn = qs('[data-add-to-cart]');
  if (stickyBuy && atcBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting;
        stickyBuy.classList.toggle('is-visible', show);
        stickyBuy.setAttribute('aria-hidden', show ? 'false' : 'true');
      },
      { threshold: 0, rootMargin: '-8px 0px 0px 0px' }
    );
    io.observe(atcBtn);
  }

  /* Introductiekorting: tab rechts midden + e-mail popup */
  (function initIntroDiscount() {
    const root = qs('[data-intro-discount]');
    if (!root) return;

    const storageKey = root.getAttribute('data-storage-key') || 'ev-intro-discount-v1';
    const code = (root.getAttribute('data-discount-code') || '').trim();
    const dialog = qs('[data-intro-dialog]', root);
    const backdrop = qs('.intro-discount__backdrop', root);
    const formStep = qs('[data-intro-step="form"]', root);
    const successStep = qs('[data-intro-step="success"]', root);
    const form = qs('form', root);
    const codeEl = qs('[data-intro-code]', root);

    function readState() {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || '{}') || {};
      } catch (e) {
        return {};
      }
    }

    function writeState(patch) {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ ...readState(), ...patch }));
      } catch (e) {}
    }

    function isDismissed() {
      const s = readState();
      return !!(s.dismissed || s.claimed);
    }

    function showTeaser() {
      if (isDismissed() || document.body.classList.contains('customer-logged-in')) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
    }

    function openDialog() {
      if (!dialog) return;
      dialog.hidden = false;
      if (backdrop) backdrop.hidden = false;
      document.body.classList.add('intro-discount-open');
      const email = qs('[data-intro-email]', root);
      if (email) requestAnimationFrame(() => email.focus());
    }

    function closeDialog() {
      if (dialog) dialog.hidden = true;
      if (backdrop) backdrop.hidden = true;
      document.body.classList.remove('intro-discount-open');
    }

    function showSuccess() {
      if (formStep) formStep.hidden = true;
      if (successStep) successStep.hidden = false;
      if (codeEl) codeEl.textContent = code;
      writeState({ claimed: true, at: Date.now() });
    }

    qsa('[data-intro-open]', root).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (e.target.closest('[data-intro-dismiss]')) return;
        openDialog();
      });
    });

    qsa('[data-intro-dismiss]', root).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        writeState({ dismissed: true, at: Date.now() });
        closeDialog();
        root.hidden = true;
      });
    });

    qsa('[data-intro-close]', root).forEach((btn) => {
      btn.addEventListener('click', closeDialog);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dialog && !dialog.hidden) closeDialog();
    });

    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const email = qs('[data-intro-email]', root);
        if (!email || !email.value) return;

        const submitBtn = qs('[data-intro-submit]', root);
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = t.introWait || 'Even geduld…';
        }

        const body = new FormData(form);
        fetch(form.getAttribute('action') || window.location.pathname, {
          method: 'POST',
          body,
          headers: { Accept: 'application/json' }
        })
          .catch(() => null)
          .finally(() => {
            showSuccess();
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.getAttribute('data-label') || t.introWait || 'Claim 10% korting';
            }
          });
      });

      const submitBtn = qs('[data-intro-submit]', root);
      if (submitBtn && !submitBtn.getAttribute('data-label')) {
        submitBtn.setAttribute('data-label', submitBtn.textContent.trim());
      }
    }

    const copyBtn = qs('[data-intro-copy]', root);
    if (copyBtn) {
      const labelCopy = copyBtn.getAttribute('data-label-copy') || t.introCopy || 'Kopieer';
      const labelCopied = copyBtn.getAttribute('data-label-copied') || t.introCopied || 'Gekopieerd';
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(code);
          copyBtn.textContent = labelCopied;
          setTimeout(() => {
            copyBtn.textContent = labelCopy;
          }, 1600);
        } catch (err) {
          copyBtn.textContent = labelCopy;
        }
      });
    }

    showTeaser();
  })();

  /* Evergetikon spaarsysteem (Appstle backend) */
  (function initEvLoyalty() {
    const root = qs('[data-ev-loyalty]');
    if (!root) return;

    const panel = qs('[data-ev-loyalty-panel]', root);
    const backdrop = qs('.ev-loyalty__backdrop', root);
    const closeBtns = qsa('[data-ev-loyalty-close]', root);
    const pointsEl = qs('[data-ev-loyalty-points]', root);
    const worthEl = qs('[data-ev-loyalty-worth]', root);
    const launcherPts = qs('[data-ev-loyalty-launcher-points]', root);
    const balanceBlock = qs('[data-ev-loyalty-balance-block]', root);
    const guestEl = qs('[data-ev-loyalty-guest]', root);
    const memberEl = qs('[data-ev-loyalty-member]', root);
    const redeemWrap = qs('[data-ev-loyalty-redeem]', root);
    const redeemPtsEl = qs('[data-ev-loyalty-redeem-points]', root);
    const redeemEuroEl = qs('[data-ev-loyalty-redeem-euro]', root);
    const redeemBtn = qs('[data-ev-loyalty-redeem-btn]', root);
    const minusBtn = qs('[data-ev-loyalty-minus]', root);
    const plusBtn = qs('[data-ev-loyalty-plus]', root);
    const statusEl = qs('[data-ev-loyalty-status]', root);
    const earnHint = qs('[data-ev-loyalty-earn-hint]', root);
    const rewardWrap = qs('[data-ev-loyalty-reward]', root);
    const codeEl = qs('[data-ev-loyalty-code]', root);
    const applyBtn = qs('[data-ev-loyalty-apply]', root);
    const cartStrip = qs('[data-ev-loyalty-cart-strip]');
    const cartPts = qs('[data-ev-loyalty-cart-points]');
    const cartWorth = qs('[data-ev-loyalty-cart-worth]');

    let redeemPoints = 100;
    let lastDiscountCode = '';
    let availablePoints = 0;

    const openBtns = () => qsa('[data-ev-loyalty-open]');

    function fmt(n) {
      const locale = document.documentElement.lang || 'nl-NL';
      return new Intl.NumberFormat(locale).format(Math.max(0, Math.floor(Number(n) || 0)));
    }

    function euroFromPoints(pts, redeemRule) {
      const per = Number(redeemRule && redeemRule.redeemPoints) || 100;
      const disc = Number(redeemRule && redeemRule.discount) || 1;
      return Math.floor(pts / per) * disc;
    }

    function moneyEuro(amount) {
      try {
        const locale = document.documentElement.lang || 'nl-NL';
        return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(amount);
      } catch (e) {
        return '€' + Number(amount).toFixed(2).replace('.', ',');
      }
    }

    function getConfig() {
      return window._ALConfig || {};
    }

    function getRedeemRule() {
      const rules = getConfig().pointRedeemRules || [];
      return rules.find((r) => r && r.status === 'ACTIVE') || rules[0] || null;
    }

    function getEarnPerEuro() {
      const rules = getConfig().pointEarnRules || [];
      const purchase = rules.find((r) => r && r.type === 'PURCHASE' && r.status === 'ACTIVE');
      return Number(purchase && purchase.basePoints) || 10;
    }

    function proxyPath() {
      return String(getConfig().proxy_path_prefix || 'apps/loyalty').replace(/^\/+|\/+$/g, '');
    }

    function setStatus(msg, kind) {
      if (!statusEl) return;
      statusEl.textContent = msg || '';
      statusEl.classList.toggle('is-error', kind === 'error');
      statusEl.classList.toggle('is-ok', kind === 'ok');
    }

    function syncRedeemUI(rule) {
      const step = Number(rule && rule.redeemPoints) || 100;
      const disc = Number(rule && rule.discount) || 1;
      const maxMultiples = Math.floor(availablePoints / step);
      if (redeemPoints < step) redeemPoints = step;
      if (maxMultiples > 0 && redeemPoints > maxMultiples * step) {
        redeemPoints = maxMultiples * step;
      }
      const euros = (redeemPoints / step) * disc;
      if (redeemPtsEl) redeemPtsEl.textContent = fmt(redeemPoints);
      if (redeemEuroEl) redeemEuroEl.textContent = '= ' + moneyEuro(euros);
      if (minusBtn) minusBtn.disabled = redeemPoints <= step || availablePoints < step;
      if (plusBtn) plusBtn.disabled = redeemPoints + step > availablePoints;
      if (redeemBtn) {
        redeemBtn.disabled = availablePoints < step;
        redeemBtn.textContent = availablePoints < step
          ? (t.loyaltyNotEnough || 'Nog niet genoeg punten')
          : withVars(t.loyaltyRedeemFor || 'Inwisselen voor {{ amount }}', { amount: moneyEuro(euros) });
      }
    }

    function render() {
      const cfg = getConfig();
      const loggedIn = root.dataset.loggedIn === 'true' || !!cfg.customerId;
      const loyalty = cfg.customerLoyalty || null;
      const rule = getRedeemRule();
      const step = Number(rule && rule.redeemPoints) || 100;

      availablePoints = Number(loyalty && loyalty.availablePoints) || 0;
      if (redeemPoints % step !== 0) redeemPoints = step;

      if (guestEl) guestEl.hidden = loggedIn;
      if (memberEl) memberEl.hidden = !loggedIn;

      if (loggedIn) {
        if (balanceBlock) balanceBlock.hidden = false;
        if (pointsEl) pointsEl.textContent = fmt(availablePoints);
        const worth = euroFromPoints(availablePoints, rule);
        if (worthEl) {
          worthEl.textContent = availablePoints > 0
            ? withVars(t.loyaltyWorth || 'Goed voor {{ amount }} korting', { amount: moneyEuro(worth) })
            : (t.loyaltySaveNext || 'Spaar bij je volgende bestelling');
        }
        if (launcherPts) {
          launcherPts.hidden = false;
          launcherPts.classList.toggle('is-empty', availablePoints <= 0);
          launcherPts.textContent = fmt(availablePoints);
        }
        if (redeemWrap) redeemWrap.hidden = false;
        syncRedeemUI(rule);

        if (cartStrip) {
          cartStrip.hidden = false;
          if (cartPts) {
            cartPts.textContent = withVars(t.loyaltyPointsCount || '{{ count }} punten', { count: fmt(availablePoints) });
          }
          if (cartWorth) {
            cartWorth.textContent = availablePoints > 0
              ? withVars(t.loyaltyEqualsDiscount || '= {{ amount }} korting', { amount: moneyEuro(worth) })
              : (t.loyaltyStartSaving || 'Begin met sparen');
          }
        }
      } else {
        if (balanceBlock) balanceBlock.hidden = true;
        if (launcherPts) {
          launcherPts.hidden = true;
          launcherPts.classList.add('is-empty');
        }
        if (cartStrip) cartStrip.hidden = true;
      }

      if (earnHint) {
        const cents = Number(root.dataset.productPrice || 0);
        const perEuro = getEarnPerEuro();
        if (cents > 0 && perEuro > 0) {
          const pts = Math.floor((cents / 100) * perEuro);
          earnHint.hidden = false;
          earnHint.textContent = withVars(
            loggedIn
              ? (t.loyaltyEarnLoggedIn || 'Spaar {{ count }} punten met dit product')
              : (t.loyaltyEarnGuest || 'Leden sparen {{ count }} punten met dit product'),
            { count: fmt(pts) }
          );
        } else {
          earnHint.hidden = true;
        }
      }

      const pdpEarn = qs('[data-product-loyalty-earn]');
      if (pdpEarn) {
        const qtyInput = qs('[data-product-form] [name="quantity"], [data-product-form] [data-qty-input]');
        syncProductLoyaltyEarn(
          Number(root.dataset.productPrice || pdpEarn.dataset.priceCents || 0),
          Math.max(1, Number(qtyInput && qtyInput.value) || 1)
        );
      }
    }

    function openPanel() {
      if (document.body.classList.contains('side-cart-open')) closeCart();
      root.classList.add('is-open');
      if (panel) {
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
      }
      if (backdrop) backdrop.hidden = false;
      openBtns().forEach((b) => b.setAttribute('aria-expanded', 'true'));
      document.body.style.overflow = 'hidden';
      const closeBtn = qs('.ev-loyalty__close', root);
      if (closeBtn) closeBtn.focus();
      render();
    }

    function closePanel() {
      root.classList.remove('is-open');
      if (panel) {
        panel.setAttribute('aria-hidden', 'true');
        window.setTimeout(() => {
          if (!root.classList.contains('is-open')) panel.hidden = true;
        }, 280);
      }
      if (backdrop) backdrop.hidden = true;
      openBtns().forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (!qs('[data-side-cart].open')) document.body.style.overflow = '';
    }

    async function applyDiscount(code) {
      if (!code) return false;
      try {
        const res = await fetch('/discount/' + encodeURIComponent(String(code).trim()), {
          credentials: 'same-origin'
        });
        return res.ok;
      } catch (e) {
        return false;
      }
    }

    async function redeem() {
      const cfg = getConfig();
      const rule = getRedeemRule();
      if (!rule || !cfg.customerId) {
        setStatus(t.loyaltyLoginToRedeem || 'Log in om punten in te wisselen.', 'error');
        return;
      }
      const step = Number(rule.redeemPoints) || 100;
      if (availablePoints < step) {
        setStatus(t.loyaltyNotEnoughStatus || 'Je hebt nog niet genoeg punten.', 'error');
        return;
      }

      redeemBtn.disabled = true;
      setStatus(t.loyaltyRedeeming || 'Bezig met inwisselen…');

      const body = {
        redeemRuleId: rule.id,
        points: redeemPoints,
        customerId: Number(cfg.customerId)
      };

      try {
        const res = await fetch('/' + proxyPath() + '/cp/api/redeem-points', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const data = await res.json().catch(() => null);
        if (!res.ok) {
          const err = (data && (data.error || data.message)) || (t.loyaltyRedeemFailed || 'Inwisselen mislukt. Probeer het opnieuw.');
          setStatus(String(err), 'error');
          redeemBtn.disabled = false;
          return;
        }

        if (data && typeof data.availablePoints === 'number') {
          cfg.customerLoyalty = Object.assign({}, cfg.customerLoyalty || {}, data);
          availablePoints = Number(data.availablePoints) || 0;
        } else if (cfg.customerLoyalty) {
          cfg.customerLoyalty.availablePoints = Math.max(0, availablePoints - redeemPoints);
        }

        const rewards = (data && data.rewards) || (cfg.customerLoyalty && cfg.customerLoyalty.rewards) || [];
        const unused = rewards.filter((r) => r && r.status === 'UNUSED' && r.discountCode);
        const newest = unused.length ? unused[unused.length - 1] : null;
        lastDiscountCode = (newest && newest.discountCode) || '';

        if (lastDiscountCode) {
          if (rewardWrap) rewardWrap.hidden = false;
          if (codeEl) codeEl.textContent = lastDiscountCode;
          const applied = await applyDiscount(lastDiscountCode);
          setStatus(
            applied
              ? (t.loyaltyDiscountApplied || 'Korting toegepast op je winkelwagen.')
              : (t.loyaltyCodeCreated || 'Code aangemaakt — klik op Toepassen.'),
            applied ? 'ok' : 'error'
          );
        } else {
          setStatus(t.loyaltyRedeemed || 'Punten ingewisseld.', 'ok');
        }
        render();
      } catch (e) {
        setStatus(t.loyaltyError || 'Er ging iets mis. Probeer het later opnieuw.', 'error');
      } finally {
        redeemBtn.disabled = false;
        syncRedeemUI(getRedeemRule());
      }
    }

    openBtns().forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (root.classList.contains('is-open')) closePanel();
        else openPanel();
      });
    });
    closeBtns.forEach((btn) => btn.addEventListener('click', closePanel));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closePanel();
    });

    if (minusBtn) {
      minusBtn.addEventListener('click', () => {
        const step = Number((getRedeemRule() || {}).redeemPoints) || 100;
        redeemPoints = Math.max(step, redeemPoints - step);
        syncRedeemUI(getRedeemRule());
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', () => {
        const step = Number((getRedeemRule() || {}).redeemPoints) || 100;
        if (redeemPoints + step <= availablePoints) redeemPoints += step;
        syncRedeemUI(getRedeemRule());
      });
    }
    if (redeemBtn) redeemBtn.addEventListener('click', redeem);
    if (applyBtn) {
      applyBtn.addEventListener('click', async () => {
        const code = lastDiscountCode || (codeEl && codeEl.textContent) || '';
        const ok = await applyDiscount(code);
        setStatus(ok ? (t.loyaltyDiscountOk || 'Korting toegepast.') : (t.loyaltyDiscountFail || 'Kon code niet toepassen.'), ok ? 'ok' : 'error');
      });
    }

    render();
    let tries = 0;
    const poll = window.setInterval(() => {
      tries += 1;
      if (window._ALConfig || tries > 40) {
        window.clearInterval(poll);
        render();
      }
    }, 250);

    document.addEventListener('shopify:section:load', render);
  })();
})();
